import styled from 'styled-components'
import { containerWidth } from '@/styled/vars'

export const RootContainer = styled.div`
  max-width: ${containerWidth};
  padding: 0 15px;
  margin: 0 auto;
`
